<template>
  <section id="page" class="section" v-on:click="sectionClicked">
    <Header class="scrolled"
      v-on:openJoin="$router.push('/')" ref="header"/>
    <div :class="{tabMenu: true, hidden: hideHeader}">
      <div class="tabMenuWrapper">
        <router-link to="/" class="tabMenuItem z">Home</router-link>
        <div class="tabMenuItem x">/</div>
        <div class="tabMenuItem y">{{detail.title}}</div>
      </div>
    </div>

    <div>
      <div class="articleDetail">
        <div class="content">
          <h2 class="articleTitle">{{detail.title}}</h2>
          <div class="articleShare articleShareStatic">
            <h4>Share</h4>
            <div class="shareCnt">
              <a target="_balnk"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                <i class="fa fa-facebook fa-fw"></i>
              </a>
              <a target="_balnk"
                :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
                <i class="fa fa-twitter fa-fw"></i>
              </a>
              <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
                <i class="fa fa-whatsapp fa-fw"></i>
              </a>
              <a target="_balnk"
                :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
                <i class="fa fa-telegram fa-fw"></i>
              </a>
              <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
                <a href='${shareUri}'>${detail.title}</a>`">
                <i class="fa fa-email fa-fw"></i>
              </a>
            </div>
          </div>
          <div class="articleContent">
            <p>Terima kasih atas kunjungan Anda ke situs Kami. Kami selalu berusaha untuk
              melakukan yang terbaik, antara lain berupaya menumbuhkan dan menjaga
              kepercayaan Anda selaku pengguna situs Kami dengan melindungi
              informasi pribadi milik Anda yang bersifat pribadi dan rahasia.
              Dengan mengunjungi & mendaftarkan diri Anda sebagai Anggota <b>Team Up For Impact</b>
              maka Anda setuju untuk terikat kepada syarat-syarat dan ketentuan
              berikut ini mengenai kebijakan privasi yang ditetapkan oleh Kami.
              Kami mungkin mengubah syarat-syarat dan kondisi ini sewaktu-waktu,
              dan oleh karenanya Anda diharapkan untuk melakukan pengecekan secara
              berkala. Bergabungnya Anda dengan <b>Team Up For Impact</b> berarti Anda menerima
              apapun syarat-syarat dan ketentuan yang baru maupun yang telah dimodifikasi.</p>

            <h4>Registrasi</h4>
            <p>Dengan Registrasi, Anda menyatakan bahwa segala informasi dan
              perubahan-perubahannya yang Anda berikan, sekarang atau dimasa
              yang akan datang adalah akurat dan benar apa adanya. Apabila
              informasi dan termasuk perubahan-perubahannya yang Anda berikan
              tersebut ternyata terbukti tidak benar, maka dengan ini Kami
              menyatakan tidak bertanggung jawab atas segala akibat yang dapat
              terjadi sehubungan dengan pemberian informasi dan
              perubahan-perubahannya yang tidak benar tersebut.</p>

            <h4>Data-data/Informasi yang diperlukan</h4>
            <p>Untuk keperluan registrasi dalam <b>Team Up For Impact</b>, Kami akan memerlukan
              data-data pribadi dari Anda antara lain sebagai berikut:</p>
            <ul>
              <li>Nama lengkap;</li>
              <li>Alamat email;</li>
            </ul>
            <p>Bahwa semua informasi yang diberikan oleh Anda tersebut akan
              Kami simpan sebaik-baiknya dengan memperhatikan faktor keamanan.</p>

            <h4>Tujuan Pengumpulan Data</h4>
            <p>Informasi dan data-data pribadi yang diperoleh oleh Kami sehubungan
              dengan Registrasi yang dilakukan oleh Anda, hanya akan digunakan
              antara lain untuk:</p>
            <ol>
              <li>Memproses aplikasi dan/atau segala bentuk pendaftaran
                dan/atau komunikasi yang diajukan oleh Anda;</li>
              <li>Melakukan komunikasi kepada Anda</li>
              <li>Memberikan tanggapan kepada Anda yang ingin mendapatkan
                keterangan dan/atau informasi lebih lanjut mengenai <b>Team Up For Impact</b>;</li>
            </ol>
            <h4>Pemberian dan Pengungkapan Informasi Kepada Pihak Lain</h4>
            <p>Bahwa kecuali untuk kepentingan pengumpulan data sebagaimana
              telah diungkapkan diatas, <b>Team Up For Impact</b> tidak akan menjual, mengalihkan,
              mendistribusikan dan/atau membuka informasi dan data-data
              pribadi Anda kepada orang lain dan/atau Pihak Ketiga yang
              tidak berkepentingan.</p>
            <p>Namun demikian Kami dapat memberikan informasi sebagaimana
              dimaksud kepada pihak-pihak yang masih berkaitan dengan Kami
              dengan syarat bahwa pihak-pihak tersebut wajib mematuhi
              Kebijakan Privasi ini.</p>
            <!--
            <p>Pihak-pihak tersebut yaitu antara lain adalah:</p>
            <ol>
              <li>Mitra koalisi <b>Team Up For Impact</b>:
                <ol>
                  <li>Kemitraan Partnership</li>
                  <li>Walhi</li>
                  <li>LTKL</li>
                  <li>Madani</li>
                </ol>
              </li>
              <li>Pihak lain yang atas nama Kami diwajibkan untuk melaksanakan
                suatu pekerjaan yang dalam pelaksanaannya perlu mengetahui
                informasi yang dilindungi tersebut.</li>
            </ol>
            -->
            <h4>Cookies</h4>
            <p>Cookies adalah sejenis file yang berisi informasi yang dikirimkan
              oleh suatu situs ke hard-drive komputer setiap pengakses situs
              tersebut untuk keperluan pencatatan oleh komputer pengakses seperti:</p>
            <ol>
              <li>Alamat Internet Protocol (IP Address) dari pengakses;</li>
              <li>Tipe browser dan operating system yang dipergunakan oleh pengakses;</li>
              <li>Hari, tanggal, dan jam saat pengakses melakukan akses terhadap suatu situs;</li>
              <li>Data yang berfungsi untuk memonitor kegiatan pengakses pada suatu situs;</li>
              <li>Alamat situs yang diakses oleh pengakses.</li>
            </ol>
            <p><b>Team Up For Impact</b> menggunakan cookies untuk berbagai
              tujuan antara lain yaitu
              untuk membantu Anda dalam hal Anda memutuskan untuk mengunjungi
              kembali <b>Team Up For Impact</b> di kemudian hari, menghitung
              jumlah orang yang melakukan
              akses ke <b>Team Up For Impact</b>.</p>
            <h4>Hukum</h4>
            <p>Syarat-syarat dan ketentuan dalam Kebijakan Privasi ini tunduk
              kepada hukum di wilayah Negara Kesatuan Republik Indonesia.</p>
          </div>
        </div>

        <div class="articleShare" :style="{top: `${shareTop}px`}">
          <h4>Share</h4>
          <div class="shareCnt">
            <a target="_balnk"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
              <i class="fa fa-facebook fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
              <i class="fa fa-twitter fa-fw"></i>
            </a>
            <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
              <i class="fa fa-whatsapp fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
              <i class="fa fa-telegram fa-fw"></i>
            </a>
            <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
              <a href='${shareUri}'>${detail.title}</a>`">
              <i class="fa fa-email fa-fw"></i>
            </a>
          </div>
        </div>
        <div ref="endArticle"/>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'read',
  components: {
    Header,
  },
  data() {
    return {
      detail: { title: 'Kebijakan Privasi' },
      related: [],
      hideHeader: false,
      shareTop: 240,
    };
  },
  methods: {
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    onScrolled() {
      const currentScrollPos = window.pageYOffset;
      const aHRect = this.$refs.endArticle.getBoundingClientRect();
      if (aHRect.top > 610) {
        this.shareTop = 240 + currentScrollPos;
      }
      if (currentScrollPos > 100) {
        if (this.prevScrollpos > currentScrollPos) {
          this.hideHeader = false;
        } else {
          this.hideHeader = true;
        }
      } else {
        this.hideHeader = false;
      }
      this.prevScrollpos = currentScrollPos;
    },
  },
  computed: {
    shareUri() {
      return `${this.$config.appUri}privacy-policy/`;
    },
  },
  created() {
    window.addEventListener('scroll', this.onScrolled);
    this.prevScrollpos = window.pageYOffset;
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScrolled);
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Kebijakan Privasi - Team Up For Impact';
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
};
</script>

<style scoped lang="scss">
.relatedWrapper{
  max-width: 750px;
  margin: 0 auto;
}
.section{
  margin: 0 auto;
}
.tabMenu{
  position: fixed;
  left: 0;
  background-color: #f5f5f5;
  right: 0;
  border-bottom: #eee 1px solid;
  transition: all .3s ease;
  z-index: 9;
  padding-left: 10px;
  padding-top: 2px;
  top: 60px;
  &.hidden{
    top: 0;
  }
  .tabMenuWrapper{
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
    // align-items: center;
    // justify-content: center;
    .tabMenuItem{
      padding: 10px 20px 8px;
      color: #444;
      cursor: pointer;
      font-weight: 600;
      border-bottom: transparent 3px solid;
      margin-bottom: -1px;
      text-decoration: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      @media (max-width: 760px) {
        padding-left: 10px;
        padding-right: 10px;
      }
      &.z{
        color: #5351a4;
        &:hover{
          color: #5351a4;
        }
      }
      &.x{
        padding-left: 0;
        padding-right: 0;
        color: #aaa;
      }
      &.y{
        color: #767676;
        font-weight: normal;
        @media (max-width: 760px) {
          max-width: 160px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
  .relatedTitle{
    width: 100%;
    margin: 0;
    margin-bottom: 14px;
    font-size: 20px;
    padding-top: 40px;
  }
  .relatedCnt{
    display: flex;
    margin-right: -20px;
    flex-wrap: wrap;
    .relatedItem{
      width: calc(33.3333% - 20px);
      margin-right: auto;
      .relatedImg{
        height: 236px;
        background-size: cover;
        background-position: center;
        background-color: #eee;
        margin-bottom: 10px;
        transition: all .2s ease;
        &:hover{
          transform: scale(1.02);
          box-shadow: 4px 4px 0 #31c1f4;
        }
      }
      a{
        text-decoration: none;
        color: #444;
        &:hover{
          color: #31c1f4;
        }
      }
      h4{
        margin: 0;
        padding-left: 7px;
      }
    }
  }
  @media (max-width: 760px){
    .relatedSc{
      margin: 0 -20px;
      overflow-x: auto;
      .relatedCnt{
        width: 780px;
        padding-left: 20px;
        padding-bottom: 10px;
        .relatedItem{
          margin: 0;
          width: 240px;
          margin-right: 20px;
          .relatedImg{
            height: 240px;
            border-radius: 10px;
          }
        }
      }
    }
  }

  .articleDetail{
    padding: 140px 0 40px;
    min-height: calc(100vh - 182px);
    .content{
      max-width: 750px;
      margin: 0 auto;
      @media (max-width: 960px) {
        max-width: none;
        margin: 0 20px;
      }
      .articleTitle{
        font-size: 40px;
        margin: 0;
        font-weight: bold;
        line-height: 1.3;
        margin-bottom: 20px;
      }
      .articleContent{
        font-size: 20px;
        line-height: 1.6;
        blockquote{
          font-size: 26px;
          line-height: 1.3;
          border-left: #ddd 4px solid;
          position: relative;
          margin: 26px 0;
          padding-bottom: 6px;
          color: #767676;
          padding-left: 50px;
          padding-left: 30px;
          &:before{
            content: "\"";
            font-size: 80px;
            position: absolute;
            left: 14px; top: -14px;
            display: none;
          }
        }
        p.caption{
          margin: -14px 0 20px 10px;
          font-size: 15px;
          line-height: 1.4;
          min-height: 22px;
        }

        p{
          margin: 0;
        }
        iframe.theMedia{
          height: 420px;
          border: none;
          @media (max-width: 700px){
            height: 200px;
          }
        }
        .theMedia{
          display: block;
          margin: 20px 0;
          width: 100%;
          border-radius: 5px;
          position: relative;
          z-index: 3;
          &.md-wide{
            width: calc(100% + 200px);
            margin: 20px -100px;
            @media (max-width: 974px) {
              width: calc(100% + 100px);
              margin: 20px -50px;
            }
            @media (max-width: 874px) {
              width: calc(100% + 40px);
              margin: 20px -20px;
              border-radius: 0;
            }
          }
        }
      }
    }
    @media (max-width: 700px) {
      // padding: 50px 0 30px;
      .content{
        .articleTitle{
          font-size: 30px;
          line-height: 1.3;
          margin-bottom: 10px;
        }
        .articleContent{
          font-size: 18px;
          line-height: 1.6;
        }
      }
    }
  }

  .authorInfo{
    position: relative;
    padding-top: 8px;
    // padding-left: 50px;
    padding-bottom: 30px;
    @media (max-width: 700px) {
      padding-bottom: 16px;
    }
    .authorImg{
      position: absolute;
      left: 0;
      top: 8px;
      width: 39px;
      height: 39px;
      background-color: #ccc;
      background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;
      display: none;
    }
    h4{
      margin: 0;
      font-size: 17px;
    }
    .publishTime{
      margin: 0;
      font-size: 14px;
    }
  }

  .articleShare{
    position: absolute;
    top: 160px;
    left: calc(((100% - 750px) / 2) - 80px);
    padding: 0 10px 5px;
    background-color: #fff;
    border-radius: 5px;
    @media (max-width: 960px) {
      margin-left: 20px;
    }
    &.articleShareStatic{
      padding-top: 0;
      padding-bottom: 20px;
      margin-left: 0;
      @media (min-width: 975px) {
        display: none;
      }
    }
    h4{
      margin: 0 0 10px;
      font-size: 12px;
      text-align: center;
      text-transform: uppercase;
      color: #767676;
    }
    a{
      display: block;
      .fa{
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 50%;
        margin: 0 auto;
        margin-top: 4px;
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;
        &:hover{
          background-color: #fff;
          opacity: 1;
        }
      }
      .fa.fa-facebook{
        background-image: url(../assets/share-facebook.png);
      }
      .fa.fa-twitter{
        background-image: url(../assets/share-twitter.png);
      }
      .fa.fa-whatsapp{
        background-image: url(../assets/share-whatsapp.png);
      }
      .fa.fa-telegram{
        background-image: url(../assets/share-telegram.png);
      }
      .fa.fa-email{
        background-image: url(../assets/share-email.png);
      }
    }
    @media (max-width: 974px) {
      position: static;
      display: flex;
      left: 0;
      top: auto;
      transform: none;
      bottom: 70px;
      border-radius: 0;
      flex-wrap: wrap;
      padding: 20px 0 0;
      h4{
        width: 50px;
        padding-top: 6px;
        width: 100%;
        text-align: left;
        margin-bottom: 6px;
        font-size: 17px;
        text-transform: none;
      }
      .shareCnt{
        display: flex;
        margin-left: -5px;
        a{
          margin: 0;
          margin-right: 10px;
          padding: 0;
          .fa{
            margin: 0;
          }
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .contentLoading{
    padding-top: 60px;
  }
</style>
